var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("timeline-item-card", {
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function () {
          return [
            !_vm.editing
              ? _c("html-iframe-preview", {
                  staticClass: "note-description p-0",
                  attrs: {
                    content: _vm.noteDescriptionHTML,
                    "break-content-words": "",
                  },
                  on: {
                    dblclick: function ($event) {
                      $event.preventDefault()
                      return _vm.editNote.apply(null, arguments)
                    },
                  },
                })
              : _c(
                  "div",
                  [
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.noteDescription,
                          expression: "noteDescription",
                        },
                      ],
                      ref: "textarea",
                      staticClass:
                        "w-100 editable-note rich-text-editor--reset p-0",
                      attrs: { id: "note-description" },
                      domProps: { value: _vm.noteDescription },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.noteDescription = $event.target.value
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "d-none",
                        attrs: { for: "note-description" },
                      },
                      [_vm._v(_vm._s(_vm.$tc("global.words.note", 1)))]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      { staticClass: "justify-content-end pb-2" },
                      [
                        _c(
                          "b-col",
                          { staticClass: "px-3", attrs: { cols: "12" } },
                          [
                            _c(
                              "button",
                              {
                                staticClass:
                                  "btn btn-primary float-right btn-xs add-list mt-3",
                                attrs: {
                                  type: "button",
                                  disabled: !_vm.canSave,
                                },
                                on: { click: _vm.handleEdit },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.$t("global.actions.saveChanges")
                                    ) +
                                    "\n          "
                                ),
                              ]
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c("timeline-card-footer", {
              attrs: { pinned: _vm.pinned },
              on: {
                pinned: function ($event) {
                  return _vm.handlePin(_vm.id, _vm.activityType, _vm.pinned)
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "left",
                  fn: function () {
                    return [
                      _c(
                        "b-col",
                        {
                          staticClass: "vertical-center mb-md-0 mb-2",
                          attrs: { cols: "12", md: "auto" },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "vertical-center" },
                            [
                              _c(
                                "profile-avatar",
                                _vm._b(
                                  {
                                    staticClass:
                                      "client-profile-owner-avatar mr-2",
                                    attrs: {
                                      "avatar-options": { inline: true },
                                    },
                                  },
                                  "profile-avatar",
                                  Object.assign({}, _vm.creator),
                                  false
                                )
                              ),
                              _vm._v(" "),
                              _c("span", { staticClass: "mr-1" }, [
                                _vm._v(_vm._s(_vm.name)),
                              ]),
                              _vm._v(" "),
                              _c("i18n", {
                                staticClass: "text-lowercase",
                                attrs: {
                                  path: "global.actions.hasCreatedA",
                                  tag: "span",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "item",
                                    fn: function () {
                                      return [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "text-secondary bold",
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.$tc(
                                                    "global.words.note",
                                                    1
                                                  )
                                                ) +
                                                "\n                "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ]),
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "px-2" }, [
                                _vm._v("-"),
                              ]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm._f("momentLocal")(
                                        _vm.createdAt,
                                        "MMM. DD, YYYY"
                                      )
                                    ) +
                                    " @\n              " +
                                    _vm._s(
                                      _vm._f("momentLocal")(_vm.createdAt, "LT")
                                    ) +
                                    "\n            "
                                ),
                              ]),
                              _vm._v(" "),
                              _vm.latestUpdate
                                ? [
                                    _c("span", { staticClass: "px-2" }, [
                                      _vm._v("|"),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "profile-avatar",
                                      _vm._b(
                                        {
                                          staticClass:
                                            "client-profile-owner-avatar mr-2",
                                          attrs: {
                                            "avatar-options": { inline: true },
                                          },
                                        },
                                        "profile-avatar",
                                        _vm.latestUpdate.user,
                                        false
                                      )
                                    ),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "mr-1" }, [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$options.filters.nameFormat(
                                              _vm.latestUpdate.user.givenName,
                                              _vm.latestUpdate.user.familyName
                                            )
                                          ) +
                                          "\n              "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$t("global.words.updated")
                                          ) +
                                          "\n                "
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "text-secondary bold" },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.$tc("global.words.note", 1)
                                              ) +
                                              "\n                "
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "px-2" }, [
                                      _vm._v("-"),
                                    ]),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm._f("momentLocal")(
                                              _vm.latestUpdate.timestamp,
                                              "MMM. DD, YYYY"
                                            )
                                          ) +
                                          " @\n                " +
                                          _vm._s(
                                            _vm._f("momentLocal")(
                                              _vm.latestUpdate.timestamp,
                                              "LT"
                                            )
                                          ) +
                                          "\n              "
                                      ),
                                    ]),
                                  ]
                                : _vm._e(),
                            ],
                            2
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        {
                          staticClass: "vertical-center mb-md-0 mb-2",
                          attrs: { cols: "12", md: "auto" },
                        },
                        [
                          _c("activity-convert-button", {
                            attrs: { id: _vm.id, "activity-type": "note" },
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "right",
                  fn: function () {
                    return [
                      _c(
                        "b-col",
                        {
                          staticClass: "vertical-center",
                          attrs: { cols: "auto" },
                        },
                        [
                          _vm.notified
                            ? _c(
                                "span",
                                {
                                  staticClass:
                                    "sent-to-referrer vertical-center pl-0 btn-sm bs-0",
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "sent-icon mr-2" },
                                    [
                                      _c(
                                        "i",
                                        {
                                          staticClass:
                                            "material-icons text-primary",
                                        },
                                        [_vm._v("mail_outline")]
                                      ),
                                      _vm._v(" "),
                                      _c("icon", {
                                        staticClass: "sent-check",
                                        attrs: { name: "check-circle" },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_vm.$tc("global.words.sent", 1)) +
                                      "\n          "
                                  ),
                                ]
                              )
                            : _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName: "v-b-tooltip.right",
                                      value: {
                                        title: _vm.$t(
                                          "client-profile.messages.noSubscribers"
                                        ),
                                        disabled: _vm.subscribers.length,
                                      },
                                      expression:
                                        "{\n              title: $t('client-profile.messages.noSubscribers'),\n              disabled: subscribers.length\n            }",
                                      modifiers: { right: true },
                                    },
                                  ],
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "clickable send-to-referrer vertical-center p-0 btn-sm bs-0",
                                      class: {
                                        "disabled no-pointer":
                                          _vm.disableSendToSubscriber,
                                      },
                                      on: { click: _vm.sendToReferrers },
                                    },
                                    [
                                      _c(
                                        "i",
                                        {
                                          staticClass:
                                            "material-icons text-primary mr-1",
                                        },
                                        [_vm._v("mail_outline")]
                                      ),
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.sending
                                              ? _vm.$t(
                                                  "client-profile.actions.sending"
                                                )
                                              : _vm.$t(
                                                  "client-profile.actions.sendSuscribers"
                                                )
                                          ) +
                                          "\n            "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        {
                          staticClass:
                            "d-flex flex-row align-items-center justify-content-end justify-content-md-start",
                          attrs: { col: "", md: "auto" },
                        },
                        [
                          _c("div", { staticClass: "dropleft ml-3" }, [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "grey-text text-darken-4 clickable vertical-center",
                                class: { disabled: _vm.disabledActions },
                                attrs: { "data-toggle": "dropdown" },
                              },
                              [
                                _c("i", { staticClass: "material-icons" }, [
                                  _vm._v("more_vert"),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "dropdown-menu" }, [
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "clickable dropdown-item text-primary edit-note",
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.editNote.apply(null, arguments)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("client-profile.actions.editNote")
                                    )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "dropdown-divider" }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "inline-prompt",
                                    {
                                      attrs: {
                                        placement: "left",
                                        "confirmation-text": _vm.$t(
                                          "client-profile.messages.deleteConfirmation",
                                          {
                                            item: _vm.$t("global.words.note"),
                                          }
                                        ),
                                      },
                                      on: { accept: _vm.handleDelete },
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "clickable dropdown-item text-danger btn-danger remove-note",
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.$t(
                                                  "client-profile.actions.deleteNote"
                                                )
                                              ) +
                                              "\n                  "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]),
                          ]),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }